import { apiClient } from './api.client';

interface ChatResponse {
  answer: string;
}

export const askQuestion = async (context: string, question: string): Promise<string> => {
  try {
    const response = await apiClient.post<ChatResponse>('/api/chat/ask', {
      context,
      question,
    });
    return response.answer;
  } catch (error) {
    console.error('Failed to ask question:', error);
    // Extract error message from ApiError if available
    if (error instanceof Error) {
      // @ts-ignore
      const message = error.data?.message || error.message;
      throw new Error(message);
    }
    throw error;
  }
};
